import React from "react";
import {CardContent, Typography} from "@mui/material";
import PageLayout from "../components/layout/PageLayout";
import {useTranslation} from "react-i18next";

const PrivacyPolicyPage = () => {
    const {t} = useTranslation();
    return (
        <PageLayout title={t("pages.privacyPolicy.title")}>
            <CardContent sx={{minHeight: 200, maxHeight: '90%', overflowY: "auto"}}>
                <h1>Privacy Policy</h1>
                <p className="effective-date"><strong>Effective date:</strong> 1st Jan 2026</p>

                <p>
                    Uramaks built the <strong>Efics</strong> app as a Freemium application.
                    This SERVICE is provided by Uramaks at no cost and is intended for use as is.
                </p>

                <p>
                    This page informs users regarding our policies on the collection, use, and
                    disclosure of personal information for anyone using our Service.
                </p>

                <p>
                    By using the Service, you agree to the collection and use of information
                    in accordance with this Privacy Policy.
                </p>

                <h2>Information Collection and Use</h2>

                <p>
                    For a better experience while using our Service, we may require you to provide
                    certain personally identifiable information. The information that we request
                    is retained on your device and/or processed by us only as described in this
                    Privacy Policy.
                </p>

                <p>
                    The app may automatically collect information such as device information,
                    unique device identifiers, app usage data, and diagnostic data.
                </p>

                <p>
                    We also use cookies and similar technologies to authenticate users and maintain
                    secure sessions.
                </p>

                <h2>Third-Party Services</h2>

                <p>
                    The app uses third-party services that may collect information used to identify
                    you. These services operate under their own Privacy Policies.
                </p>

                <ul>
                    <li>Google Play Services</li>
                    <li>AdMob</li>
                    <li>Appodeal</li>
                    <li>Firebase Analytics</li>
                    <li>Firebase Crashlytics</li>
                </ul>

                <h2>App Permissions and Personal Data</h2>

                <p>
                    Depending on the User’s device, the app may request certain permissions that
                    allow access to device data. Permissions can be revoked at any time through
                    device settings, though some features may stop working.
                </p>

                <h3>Camera</h3>
                <p>
                    Used to capture images and attach photos to transactions or records.
                </p>

                <h3>SMS</h3>
                <p>
                    Used for reading and parsing SMS messages related to app functionality.
                </p>

                <h3>Storage</h3>
                <p>
                    Used to read and write files such as backups and transaction images.
                </p>

                <h3>Reminders / Notifications</h3>
                <p>
                    Used to create and manage reminders or notifications related to app activity.
                </p>

                <h3>Account Information</h3>
                <p>
                    Used to access basic account information such as email address when supported
                    sign-in services are used.
                </p>

                <h2>Cookies and Authentication</h2>

                <p>
                    <strong>Efics uses cookies and similar technologies for authentication
                        purposes</strong>, including maintaining user sessions, securely signing users
                    in, and preventing unauthorized access.
                </p>

                <p>
                    These cookies are essential for the proper functioning of the Service. Disabling
                    authentication cookies may prevent access to certain features.
                </p>

                <p>
                    Third-party services integrated into the app may also use cookies or similar
                    technologies for analytics and advertising purposes.
                </p>

                <h2>Log Data</h2>

                <p>
                    In case of an error in the app, we collect data and information through
                    third-party tools called Log Data. This may include IP address, device name,
                    operating system version, app configuration, date and time of use, and other
                    statistics.
                </p>

                <h2>Service Providers</h2>

                <p>
                    We may employ third-party companies and individuals to facilitate our Service,
                    perform Service-related tasks, or help analyze usage. These third parties have
                    access to Personal Information only to perform tasks on our behalf and are
                    obligated not to disclose or use it for other purposes.
                </p>

                <h2>Data Security</h2>

                <p>
                    We strive to use commercially acceptable means to protect your information,
                    but no method of transmission over the internet or electronic storage is
                    100% secure.
                </p>

                <h2>Children’s Privacy</h2>

                <p>
                    This Service is not intended for children under the age of 13. We do not
                    knowingly collect personally identifiable information from children.
                </p>

                <h2>Links to Other Sites</h2>

                <p>
                    This Service may contain links to external sites. We are not responsible for
                    the content, privacy policies, or practices of third-party websites.
                </p>

                <h2>Changes to This Privacy Policy</h2>

                <p>
                    We may update this Privacy Policy from time to time. Any changes will be posted
                    on this page and are effective immediately after posting.
                </p>

                <h2>Contact Us</h2>

                <div className="contact">
                    <p>
                        If you have any questions or suggestions about this Privacy Policy,
                        please contact us:
                    </p>
                    <p>
                        <strong>Developer:</strong> Uramaks<br/>
                        <strong>Email:</strong> support@uramaks.com
                    </p>
                </div>
            </CardContent>
        </PageLayout>
    );
};

export default PrivacyPolicyPage;
